import { createReducer, on } from '@ngrx/store';

import {
  authenticate,
  authenticateFailure,
  authenticateSuccess,
  connectToWebsocket,
  connectToWebsocketSuccess,
  dismissConnectionLostOverlay,
  showConnectionLostOverlay,
  websocketClosed,
  websocketConnectionLost,
  websocketFailure,
} from './websocket.actions';

export interface WebsocketState {
  online: boolean | null;
  connectionInProgress: boolean;
  websocketError?: string;
  authenticationInProgress: boolean;
  authenticationError?: string;
  authenticated: boolean;
  connectionLost: boolean;
  connectionLostOverlayCanBeShown: boolean;
  connectionLostOverlayDismissed: boolean;
}

export const initialState: WebsocketState = {
  online: null,
  connectionInProgress: false,
  authenticationInProgress: false,
  authenticated: false,
  connectionLost: false,
  connectionLostOverlayCanBeShown: false,
  connectionLostOverlayDismissed: false,
};

export const websocketFeatureKey = 'websocket';

export const websocketReducer = createReducer(
  initialState,

  on(connectToWebsocket, (state) => ({
    ...state,
    websocketError: undefined,
    connectionInProgress: true,
    authenticated: false,
    authenticationInProgress: false,
    authenticationError: undefined,
  })),
  on(connectToWebsocketSuccess, (state) => ({
    ...state,
    online: true,
    connectionInProgress: false,
    connectionLost: false,
    connectionLostOverlayCanBeShown: false,
    connectionLostOverlayDismissed: false,
  })),
  on(websocketFailure, (state, { error }) => ({
    ...state,
    connectionInProgress: false,
    websocketError: error,
    authenticated: false,
    authenticationInProgress: false,
    authenticationError: undefined,
  })),
  on(websocketClosed, (state) => ({
    ...state,
    online: false,
    websocketError: undefined,
    authenticated: false,
    authenticationInProgress: false,
    authenticationError: undefined,
  })),
  on(authenticate, (state) => ({
    ...state,
    authenticationInProgress: true,
    authenticationError: undefined,
    authenticated: false,
  })),
  on(authenticateSuccess, (state) => ({
    ...state,
    authenticationInProgress: false,
    authenticated: true,
  })),
  on(authenticateFailure, (state, { error }) => ({
    ...state,
    authenticationInProgress: false,
    authenticationError: error,
  })),
  on(websocketConnectionLost, (state) => ({ ...state, connectionLost: true })),
  // Deliberately keeps the dismissed flag intact — the show action refires on every failed reconnect attempt
  on(showConnectionLostOverlay, (state) => ({ ...state, connectionLostOverlayCanBeShown: true })),
  on(dismissConnectionLostOverlay, (state) => ({ ...state, connectionLostOverlayDismissed: true }))
);
